import $ from "jquery";

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}

// $('.faq-section .masonry-grid--item-toggler').on('click', function (){
//     $(this).toggleClass('--active');
//     $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body').slideToggle();
// })